import ViewBase from "../view-base.view";
import { Button, Dialog, Icons } from "construct-ui";
import HomeDashboardModel from "../../models/home/home-dashboard.model";
import DashboardSettingsView from "./dashboard-settings.view";
import { WIDGET_STATUS } from "../../config/global-variables";
import loginModel from "../../models/login.model";
import PopupNoticeComponent from "../../components/notification/popup-notice.component";

export default function HomeDashboardView() {

  ViewBase.call(this);

  let showSettingsModal = false;
  let widgetList = [];
  let currentLanguage = "";

  let getWidgetListForDisplay = () => {
    this.showLoading();
    widgetList = [];
    HomeDashboardModel.getHomeWidgetLayoutSettings(
      (result) => {
        widgetList = result || [];
        widgetList.sort(HomeDashboardModel.compareWidgetSequence); // Sort widgets by sequence
        this.hideLoading();
      }, (error) => {
        this.hideLoading();
        this.handleError(error);
      }
    );
  }

  return {
    oninit: (vnode) => {
      currentLanguage = loginModel.credentials.language;
      getWidgetListForDisplay();
    },
    onupdate: () => {
      if (loginModel.credentials?.language && currentLanguage !== loginModel.credentials.language) {
        currentLanguage = loginModel.credentials.language;
        getWidgetListForDisplay();
      }
    },
    view: (vnode) => {
      return [
        widgetList?.length > 0
          ? [
            m('.d-flex.justify-content-end', [
              m(Button, {
                basic: true,
                style: 'padding-right: 0.25rem; padding-left: 0.25rem;',
                iconLeft: Icons.SETTINGS,
                label: this.getText('LT00000288', 'Settings'),
                onclick: e => showSettingsModal = true,
              }),
            ]),
            widgetList.filter(w => w.status === WIDGET_STATUS.ACTIVE).map(w => [
              m('.home-widget.mb-3', { key: w.widgetMstID + '_' + currentLanguage },
                HomeDashboardModel.getWidgetById(w.widgetMstID),
              )
            ]),
            m(Dialog, {
              closeOnOutsideClick: false,
              isOpen: showSettingsModal,
              onClose: e => showSettingsModal = false,
              transitionDuration: 200,
              title: this.getText('LT00000107', 'Dashboard Settings'),
              content: m(DashboardSettingsView, {
                onClose: (o) => { showSettingsModal = o; },
                triggerRefresh: (isUpdated, updatedWidgetList) => {
                  if (isUpdated) {
                    widgetList = updatedWidgetList;
                    widgetList.sort(HomeDashboardModel.compareWidgetSequence); // Sort updated widgets by sequence
                    m.redraw();
                  }
                }
              }),
              "class": "cui-dialog-l"
            }),
          ]
          : null,
        m(PopupNoticeComponent),
        this.getBaseViews()
      ]; // end of return
    }
  }
}
